namespace app.quickPanel.notification {
    "use strict";
    
    import Properties = app.support.constants.Properties;
    import INotification = app.notification.INotification;
    import IdentidadesService = app.support.identidades.IdentidadesService;
    
    export interface IFeedItem {
        
        uuid: string;
        title: string;
        description: string;
        sender: string;
        creationDate: number;
        read: boolean;
    }
	
    export class FeedService {
        
        private apiNotifications: string = '/integracoes-modulos/api/notifications';

        /** @ngInject */
        public constructor(private $http: ng.IHttpService,
                           private $rootScope: ng.IRootScopeService,
                           private $cookies: ng.cookies.ICookiesService,
                           properties: Properties,
                           private identidadesService: IdentidadesService) {

            this.apiNotifications = properties.apiUrl + this.apiNotifications;
        }
        
        public list(): ng.IPromise<IFeedItem[]> {
            return this.$http.get(this.apiNotifications)
                .then((response: ng.IHttpPromiseCallbackArg<INotification[]>) => {
                    let notifications: INotification[] = response.data;
                    let unread : number = 0;
                
                    let feed: IFeedItem[] = notifications
                    	.filter((notification) => !!notification)
                    	.map((notification) => {
                        	unread += (notification.read ? 0 : 1);
                        	return this.toFeedItem(notification);
                    	});
                    this.$rootScope.$broadcast('feed:unread', unread);
                
                    return feed;
                }); 
        }
        
        public read(itens: IFeedItem[]): ng.IHttpPromise<{}> {
            if (!angular.isArray(itens)) {
                throw new Error("Notificações não informadas!");
            }
            
            let uuids: string[] = [];
        
            itens.forEach((item) => {
                item.read = ! item.read;
                uuids.push(item.uuid);
            });
            return this.$http.post(this.apiNotifications, uuids);
        }
        
        public remove(uuid: string): ng.IHttpPromise<{}> {
            return this.$http.delete(this.apiNotifications + "/" + uuid);
        }
        
        public removeAll(): ng.IHttpPromise<{}> {
            return this.$http.delete(this.apiNotifications + "/all");
        }
        
        public toFeedItem(notification: INotification): IFeedItem {
            let feedItem: IFeedItem = notification.content;
            feedItem.uuid = notification.uuid;
            feedItem.sender = notification.sender;
            feedItem.creationDate = notification.creationDate;
            return feedItem;
        }

        public getNomeApresentacao(loginUsuarios: string[]): ng.IPromise<Map<string, string>> {
            return this.identidadesService.getNomeApresentacao(loginUsuarios);
        }
    }
    
    angular
        .module("app.quick-panel")
        .service("app.quick-panel.FeedService", FeedService);
}